export enum TimezoneDataHooks {
  Main = 'timezone',
  singleTimezone = 'single-timezone',
  multiTimezone = 'multi-timezone',
}
